import { render, staticRenderFns } from "./UserAddAuthorization.vue?vue&type=template&id=3342c2d5&scoped=true&"
import script from "./UserAddAuthorization.vue?vue&type=script&lang=js&"
export * from "./UserAddAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./UserAddAuthorization.vue?vue&type=style&index=0&id=3342c2d5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342c2d5",
  null
  
)

export default component.exports